"use strict";

var _inherits = require("/Users/btton/Desktop/Kitton/ReactApp/magbizcloudsystem/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/Users/btton/Desktop/Kitton/ReactApp/magbizcloudsystem/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/btton/Desktop/Kitton/ReactApp/magbizcloudsystem/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _classCallCheck = require("/Users/btton/Desktop/Kitton/ReactApp/magbizcloudsystem/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/btton/Desktop/Kitton/ReactApp/magbizcloudsystem/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var key = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5
};
var webkit = ['webkitFullscreenEnabled', 'webkitFullscreenElement', 'webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitfullscreenchange', 'webkitfullscreenerror'];
var moz = ['mozFullScreenEnabled', 'mozFullScreenElement', 'mozRequestFullScreen', 'mozCancelFullScreen', 'mozfullscreenchange', 'mozfullscreenerror'];
var ms = ['msFullscreenEnabled', 'msFullscreenElement', 'msRequestFullscreen', 'msExitFullscreen', 'MSFullscreenChange', 'MSFullscreenError'];
var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
var vendor = 'fullscreenEnabled' in document && Object.keys(key) || webkit[0] in document && webkit || moz[0] in document && moz || ms[0] in document && ms || [];
var fscreen = /*#__PURE__*/function () {
  function fscreen() {
    _classCallCheck(this, fscreen);
  }
  _createClass(fscreen, null, [{
    key: "requestFullscreen",
    value: function requestFullscreen(element) {
      return element[vendor[key.requestFullscreen]]();
    }
  }, {
    key: "requestFullscreenFunction",
    value: function requestFullscreenFunction(element) {
      return element[vendor[key.requestFullscreen]];
    }
  }, {
    key: "exitFullscreen",
    get: function get() {
      return document[vendor[key.exitFullscreen]].bind(document);
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(type, handler, options) {
      return document.addEventListener(vendor[key[type]], handler, options);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, handler, options) {
      return document.removeEventListener(vendor[key[type]], handler, options);
    }
  }, {
    key: "fullscreenEnabled",
    get: function get() {
      return Boolean(document[vendor[key.fullscreenEnabled]]);
    },
    set: function set(val) {}
  }, {
    key: "fullscreenElement",
    get: function get() {
      return document[vendor[key.fullscreenElement]];
    },
    set: function set(val) {}
  }, {
    key: "onfullscreenchange",
    get: function get() {
      return document["on".concat(vendor[key.fullscreenchange]).toLowerCase()];
    },
    set: function set(handler) {
      document["on".concat(vendor[key.fullscreenchange]).toLowerCase()] = handler;
    }
  }, {
    key: "onfullscreenerror",
    get: function get() {
      return document["on".concat(vendor[key.fullscreenerror]).toLowerCase()];
    },
    set: function set(handler) {
      document["on".concat(vendor[key.fullscreenerror]).toLowerCase()] = handler;
    }
  }]);
  return fscreen;
}();
;
var FullScreen = /*#__PURE__*/function (_React$Component) {
  _inherits(FullScreen, _React$Component);
  var _super = _createSuper(FullScreen);
  function FullScreen(props) {
    var _this;
    _classCallCheck(this, FullScreen);
    _this = _super.call(this, props);
    _this.detectFullScreen = function () {
      if (_this.props.onChange) {
        _this.props.onChange(!!fscreen.fullscreenElement);
      }
      if (_this.props.onOpen && !!fscreen.fullscreenElement) {
        _this.props.onOpen();
      }
      if (_this.props.onClose && !fscreen.fullscreenElement) {
        _this.props.onClose();
      }
    };
    _this.enterFullScreen = function () {
      fscreen.requestFullscreen(_this.node);
    };
    _this.leaveFullScreen = function () {
      fscreen.exitFullscreen();
    };
    return _this;
  }
  _createClass(FullScreen, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      fscreen.addEventListener('fullscreenchange', this.detectFullScreen, {});
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      fscreen.removeEventListener('fullscreenchange', this.detectFullScreen, {});
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.handleProps(this.props);
    }
  }, {
    key: "handleProps",
    value: function handleProps(props) {
      var enabled = fscreen.fullscreenElement;
      if (enabled && !props.enabled) {
        this.leaveFullScreen();
      } else if (!enabled && props.enabled) {
        this.enterFullScreen();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return React.createElement("div", {
        className: "FullScreen",
        ref: function ref(node) {
          return _this2.node = node;
        },
        style: {
          height: '100%',
          width: '100%'
        }
      }, this.props.children);
    }
  }]);
  return FullScreen;
}(React.Component);
exports.default = FullScreen;
FullScreen.defaultProps = {
  enabled: false
};